import { useLiveQuery } from 'dexie-react-hooks';
import { useCallback, useSyncExternalStore } from 'react';
import { db } from '../lib/db';
import { isSyncing, subscribeSyncing, syncPendingExpenses } from '../lib/sync';

/** Contagem de itens pendentes/falhos na fila (outbox) + estado "sincronizando…". */
export function useSyncQueue() {
  const pendingCount = useLiveQuery(
    () => db.pendingExpenses.where('status').anyOf('pending', 'syncing').count(),
    [],
  );
  const failedCount = useLiveQuery(
    () => db.pendingExpenses.where('status').equals('failed').count(),
    [],
  );
  const syncing = useSyncExternalStore(subscribeSyncing, isSyncing, isSyncing);

  const triggerSync = useCallback(() => {
    void syncPendingExpenses();
  }, []);

  return {
    pendingCount: pendingCount ?? 0,
    failedCount: failedCount ?? 0,
    syncing,
    triggerSync,
  };
}
